import { render, staticRenderFns } from "./InquiryCreate.vue?vue&type=template&id=0bc955da"
import script from "./InquiryCreate.vue?vue&type=script&lang=js"
export * from "./InquiryCreate.vue?vue&type=script&lang=js"
import style0 from "./InquiryCreate.vue?vue&type=style&index=0&id=0bc955da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports